export const errorSelector = (state) => {
  return state.chat.error && state.members.error && state.organizations.error && state.clients.error;
};
